import React from 'react'

import { PanelDetails } from 'components/attacks/details/AttackStyles'
import { MFAOld } from 'components/profile/to-be-removed/MFAOld'
import ResetPasswordOld from 'components/profile/to-be-removed/ResetPasswordOld'
import { isPrivateEdition } from 'utils/app-config'

/**
 * @deprecated
 */
export const UserSecurityOld = () => {
  return (
    <PanelDetails>
      <ResetPasswordOld />
      {!isPrivateEdition() && <MFAOld />}
    </PanelDetails>
  )
}
